// extracted by mini-css-extract-plugin
module.exports = {"container":"bulkEmails_container__HvDbr","title":"bulkEmails_title__1p-dV","content":"bulkEmails_content__2NZEc"};